import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { Tool, Objective, ProjectService, Activity, Project } from 'toolbandi-ui-lib';
import { Observable, forkJoin } from 'rxjs';
import { CrudService, MessageService } from 'elbuild-ui-lib-core';
import { TranslateService } from '@ngx-translate/core';
import * as screenfull from 'screenfull';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ProjectToolAddComponent } from '../project-tool-add/project-tool-add.component';

@Component({
	selector: 'app-project-tools',
	templateUrl: './project-tools.component.html',
	styleUrls: ['./project-tools.component.scss']
})
export class ProjectToolsComponent implements OnInit {

	@Input()
	projectid: number;
	project: Project;
	@Input()
	companyid: number;

	tools: Tool[];
	objectives: Objective[];
	loading: boolean;

	@ViewChild('tablearea', { static: true }) tablearea: ElementRef;
	tablefull: boolean;
	activities: any;


	constructor(
		private objectiveService: CrudService<Objective>,
		private activityService: CrudService<Activity>,
		private projectService: ProjectService,
		private messageService: MessageService,
		private translateService: TranslateService,
		private modalService: NgbModal,
		private projectCrudService: CrudService<Project>
	) { }

	ngOnInit() {
		if (this.projectid) {
			this.load();
			this.projectCrudService.getEntity(Project, 'project', this.projectid).subscribe((p: Project) => this.project = p);
		}

	}

	load() {

		this.loading = true;
		const requests: Observable<any>[] = [];

		requests.push(this.objectiveService.getFiltered(Objective, 'objective', 'projectid', this.projectid + ''));
		requests.push(this.projectService.getActivityToolMatrix(this.projectid, this.companyid));
		requests.push(this.activityService.countFiltered(Activity, 'activity', 'projectid', this.projectid + ''));

		forkJoin(requests).subscribe(data => {
			this.objectives = data[0];
			this.tools = data[1];
			this.activities = data[2];
			this.loading = false;
		}, ({ error }) => {
			this.messageService.sendError(error, this.translateService.instant('labels.error-occurred'));
			this.loading = false;
		});


	}


	toggle(a: Activity, tool: Tool) {
		// a['r' + r.id] = !a['r' + r.id];

		if (!(this.project.isDraft)) {
			return;
		}
		if (a && tool) {
			const activitytool = tool.getActivityTool(a.id);
			if (!activitytool) {

				this.projectService.addActivityTool(a.id, tool.id).subscribe(data => {

					tool.addActivity(data);
				}, ({ error }) => {
					this.messageService.sendError(error, this.translateService.instant('labels.error-occurred'));
					this.loading = false;
				});
			} else {
				this.projectService.removeActivityTool(activitytool.id).subscribe(data => {
					tool.removeActivity(a.id);
				}, ({ error }) => {
					this.messageService.sendError(error, this.translateService.instant('labels.error-occurred'));
					this.loading = false;
				});
			}
		}
	}

	toggleFullscreen() {
		const s = screenfull as screenfull.Screenfull;
		if (this.tablefull) {

			if (s.isFullscreen) {
				s.exit();
				this.tablefull = false;
			}
		} else {
			if (s.enabled && this.tablearea && this.tablearea.nativeElement) {
				s.toggle(this.tablearea.nativeElement);
				this.tablefull = true;
			}
		}

	}

	add(): void {

		const modal = this.modalService.open(ProjectToolAddComponent, {
			centered: true,
			size: 'lg',
			backdrop: 'static',
			keyboard: false
		});
		modal.componentInstance.projectid = this.projectid;
		if (this.companyid) {
			modal.componentInstance.singlecompany = true;
			modal.componentInstance.companyid = this.companyid;
		}
		modal.componentInstance.loadAssociabletools();
		modal.componentInstance.loadAssociatetools();


		modal.result.then(() => {
			this.load();
		}).catch(() => {
			this.load();
		});

	}

}
